import { Stack } from '@mui/material';
import { FlowNotableObject, type FlowUpdateNotableObjectConfig } from 'flow-schema';
import { type ComponentType } from 'react';

import { isDefined } from 'common';

import { UpdateAssistantFormFields } from './FormFields/UpdateAssistantFormFields';
import { UpdateEncounterFormFields } from './FormFields/encounterFormFields';
import { UpdatePatientFormFields } from './FormFields/patientFormFields';
import { UpdatePatientInsuranceInformationFormFields } from './FormFields/patientInsuranceInformationFormFields';
import { UpdatePatientOrderFormFields } from './FormFields/patientOrderFormFields';
import { UpdatePatientUploadFormFields } from './FormFields/patientUploadFormFields';
import { UpdatePaymentFormFields } from './FormFields/paymentFormFields';
import { UpdateProviderFormFields } from './FormFields/providerFormFields';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

// TODO: Remove Partial<> once all NotableObjects are implemented here
const UPDATE_NOTABLE_OBJECT_FORM_FIELDS: Partial<Record<FlowNotableObject, ComponentType>> = {
  [FlowNotableObject.Assistant]: UpdateAssistantFormFields,
  [FlowNotableObject.Encounter]: UpdateEncounterFormFields,
  [FlowNotableObject.PatientOrder]: UpdatePatientOrderFormFields,
  [FlowNotableObject.Payment]: UpdatePaymentFormFields,
  [FlowNotableObject.Provider]: UpdateProviderFormFields,
  [FlowNotableObject.Patient]: UpdatePatientFormFields,
  [FlowNotableObject.PatientInsuranceInformation]: UpdatePatientInsuranceInformationFormFields,
  [FlowNotableObject.PatientUpload]: UpdatePatientUploadFormFields,
};

export function UpdateNotableObjectFormFields() {
  const { value: notableObject } =
    useSelectedNodeField<FlowUpdateNotableObjectConfig['notableObject']>('config.notableObject');
  const FormFields = isDefined(notableObject)
    ? UPDATE_NOTABLE_OBJECT_FORM_FIELDS[notableObject]
    : undefined;

  return (
    <Stack gap={3}>
      <BlockSelectField
        label="Notable Object"
        fieldName="config.notableObject"
        required
        options={Object.keys(UPDATE_NOTABLE_OBJECT_FORM_FIELDS)
          .filter((candidateNotableObject) => {
            // TODO(https://app.asana.com/1/1187495389489253/project/1210181014380523/task/1219607670692354?focus=true):
            // remove Assistant entirely once no flow definitions reference it.
            if ((candidateNotableObject as FlowNotableObject) === FlowNotableObject.Assistant) {
              return false;
            }
            return true;
          })
          .map((notableObject) => ({
            label: notableObject,
            value: notableObject,
          }))}
      />
      {isDefined(FormFields) && <FormFields />}
    </Stack>
  );
}
